const TopicName = {
    InvoiceRequests: "invoice-requests",
    InvoiceRequestsV2: "invoice-requests-v2"
};

export default TopicName;
